// Privilege helpers — consumes `role.rolePrivileges` from the login response.
//
// This is UX-only gating, not security. Backend enforcement (`requirePrivilege`)
// is shadow-mode only right now, so the frontend check is currently the only
// real access control for privilege-gated UI. See
// docs/privilege-system-frontend-playbook.html in the backend repo.

export const getCurrentUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem("user"));
  } catch (error) {
    return null;
  }
};

// Flattens the nested rolePrivileges array into a Set of privilege slugs,
// e.g. { moduleSubAppPrivilege: { slug: "createACourse", ... } } -> "createACourse".
// Always returns a Set, even for missing/empty/malformed data — the fail-safe
// direction is "show nothing", never "show everything".
export const getPrivilegeSlugs = (user = getCurrentUser()) => {
  const rolePrivileges = user?.role?.rolePrivileges;
  if (!Array.isArray(rolePrivileges)) return new Set();

  return new Set(
    rolePrivileges
      .map((rolePrivilege) => rolePrivilege?.moduleSubAppPrivilege?.slug)
      .filter(Boolean)
  );
};

// A route/section with no privileges array is intentionally ungated (e.g.
// Dashboard, or areas — like Audit Log — that don't have a catalog entry yet).
export const hasPrivilege = (slug, user) => {
  if (!slug) return true;
  return getPrivilegeSlugs(user).has(slug);
};

export const hasAnyPrivilege = (slugs = [], user) => {
  if (!slugs || slugs.length === 0) return true;
  const privilegeSlugs = getPrivilegeSlugs(user);
  return slugs.some((slug) => privilegeSlugs.has(slug));
};
